module.exports = __webpack_public_path__ + "library.64c19f8c59b440771e29ba50d59bdde3.png";